export default __webpack_public_path__ + "static/media/basf-img-4.7fd90e85.jpeg";